import React, { useState, useEffect } from "react";
// export let host = window.location.hostname === "localhost" ? "http://localhost/apis/siamik/" : "https://apis.naylatools.com/siamik/";
export let host = "https://apis.naylatools.com/siamik/";

export const Token = localStorage.getItem("TokenAdmin");

export const pilihMenu = (Menu) => {
    let cls = document.getElementsByClassName("active-menu");
    for (let i = 0; i < cls.length; i++) {
        cls[i].classList.remove("active-menu");
    }
    document.getElementById(Menu).classList.add("active-menu");
}

export async function cekSesi() {
    let cekSesi = await api("sesi", { act: "cek" });
    console.log(cekSesi);
    if (cekSesi.status == "gagal") {
        if (cekSesi.pesan == "sesi tidak ditemukan") {
            localStorage.removeItem("TokenApp");
            localStorage.removeItem("UserType");
        }
    } else {
        return true;
    }
}

export const parseJsonObj = function (str) {
    try {
        return JSON.parse(str);
    } catch (e) {
        return {};
    }
}

export const parseJsonArr = function (str) {
    try {
        return JSON.parse(str);
    } catch (e) {
        return [];
    }
}

export function get1Year(tanggal) {
    const date = new Date(tanggal);
    date.setFullYear(date.getFullYear() + 1);

    const tahun = date.getFullYear();
    const bulan = (date.getMonth() + 1).toString().padStart(2, '0');
    const hari = date.getDate().toString().padStart(2, '0');

    return `${tahun}-${bulan}-${hari}`;
}

export const getJamSaatIni = function () {
    const tanggal = new Date();
    const jam = tanggal.getHours().toString().padStart(2, '0');
    const menit = tanggal.getMinutes().toString().padStart(2, '0');
    const detik = tanggal.getSeconds().toString().padStart(2, '0');
    return `${jam}:${menit}:${detik}`;
}

export function getRentangDate(startDate, endDate) {
    const start = new Date(startDate);
    const end = new Date(endDate);
    const dateArray = [];

    if (start > end) {
        throw new Error("Tanggal awal tidak boleh lebih besar dari tanggal akhir");
    }

    let currentDate = start;
    while (currentDate <= end) {
        if (currentDate.getDay() !== 0) {
            dateArray.push(currentDate.toISOString().split('T')[0]);
        }
        currentDate.setDate(currentDate.getDate() + 1);
    }

    return dateArray;
}

export const InstallButton = () => {
    const [deferredPrompt, setDeferredPrompt] = useState(null);
    const [isInstalled, setIsInstalled] = useState(false);
    let OpenFrom = document.getElementById('edtOpenFrom').value;

    useEffect(() => {
        const handleBeforeInstallPrompt = (e) => {
            e.preventDefault();
            setDeferredPrompt(e);
        };

        window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);

        window.addEventListener('appinstalled', () => {
            setIsInstalled(true);
        });

        return () => {
            window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
            window.removeEventListener('appinstalled', () => {
                setIsInstalled(true);
            });
        };
    }, []);

    const handleInstallClick = async () => {
        if (deferredPrompt) {
            deferredPrompt.prompt();
            const { outcome } = await deferredPrompt.userChoice;
            if (outcome === 'accepted') {
                console.log('User accepted the install prompt');
                setDeferredPrompt(null);
            } else {
                console.log('User dismissed the install prompt');
            }
        }
    };

    if (isInstalled) {
        return null;
    }
    if (OpenFrom == "Web") {
        return (
            <div style={{ position: "fixed", bottom: "200px", right: "20px" }}>
                {deferredPrompt && (
                    <button onClick={handleInstallClick} className="btn btn-default" style={{ borderRadius: "50%" }}>
                        <i className="fas fa-download"></i>
                    </button>
                )}
            </div>
        );
    }
};

export const TampilBulan = function (date) {
    let bulan = date.substring(5);
    let tahun = date.substring(0, 4);
    let BulanIndo = ["Jan", "Feb", "Mar", "Apr", "Mei", "Jun", "Jul", "Agust", "Sept", "Okt", "Nov", "Des"];
    let hasil = `${BulanIndo[bulan - 1]} ${tahun}`;
    return hasil;
}

export const saiki = function (first = null) {
    var today = new Date();
    var dd = first == null ? today.getDate() : first;
    var mm = today.getMonth() + 1;
    var yyyy = today.getFullYear();
    if (dd < 10) { dd = '0' + dd; }
    if (mm < 10) { mm = '0' + mm; }
    today = yyyy + '-' + mm + '-' + dd;
    return today;
}

export function checkDateFormat(tgl) {
    if (tgl == undefined || tgl == null) {
        return saiki();
    } else {
        let today = new Date();
        let dd = today.getDate();
        let mm = today.getMonth() + 1;
        let yyyy = today.getFullYear();
        if (dd < 10) { dd = '0' + dd; }
        if (mm < 10) { mm = '0' + mm; }
        let tanggal = yyyy + '-' + mm + '-' + dd;
        if (tgl.length == 5) {
            let utc_days = Math.floor(tgl - 25569);
            let utc_value = utc_days * 86400;
            let date_info = new Date(utc_value * 1000);
            let fractional_day = tgl - Math.floor(tgl) + 0.0000001;
            let total_seconds = Math.floor(86400 * fractional_day);
            let seconds = total_seconds % 60;
            total_seconds -= seconds;
            let hours = Math.floor(total_seconds / (60 * 60));
            let minutes = Math.floor(total_seconds / 60) % 60;
            let MM = date_info.getMonth() + 1;
            let DD = date_info.getDate();
            let bln = MM < 10 ? "0" + MM : MM;
            let Tgl = DD < 10 ? "0" + DD : DD;
            tanggal = date_info.getFullYear() + "-" + bln + "-" + Tgl;
        } else {
            let slash = tgl.split("/");
            let dash = tgl.split("-");
            if (dash.length > 1) {
                let YY = dash[0].length == 4 ? dash[0] : dash[2];
                let MM = dash[1];
                let DD = dash[0].length == 4 ? dash[2] : dash[0];
                tanggal = `${YY}-${MM}-${DD}`;
            } else if (slash.length > 1) {
                let YY = slash[0].length == 4 ? slash[0] : slash[2];
                let MM = slash[1];
                let DD = slash[0].length == 4 ? slash[2] : slash[0];
                tanggal = `${YY}-${MM}-${DD}`;
            }
        }
        return tanggal;
    }
}

export const isJson = function (str) {
    try {
        JSON.parse(str);
    } catch (e) {
        return false;
    }
    return true;
}

export const setCookie = function (cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    var expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

export const getCookie = function (cname) {
    var name = cname + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}

export const YYMMDD = function (date) {
    var d = new Date(date),
        month = '' + (d.getMonth()),
        day = '' + d.getDate(),
        year = d.getFullYear();

    if (month.length < 2)
        month = '0' + month;
    if (day.length < 2)
        day = '0' + day;

    return [year, month, day].join('-');
}

export const tanggalIndo = function (data) {
    var d = new Date(data),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();

    if (month.length < 2)
        month = '0' + month;
    if (day.length < 2)
        day = '0' + day;

    let hasil = [year, month, day].join('-');

    if (hasil == "0000-00-00" || hasil == null) {
        return (hasil);
    } else {
        let BulanIndo = ["Jan", "Feb", "Mar", "Apr", "Mei", "Jun", "Jul", "Agust", "Sept", "Okt", "Nov", "Des"];

        let tahun = hasil.substring(2, 4);
        let bulan = hasil.substring(5, 7);
        let tgl = hasil.substring(8, 10);

        let result = `${tgl} ${BulanIndo[bulan - 1]} ${tahun}`;
        return result;
    }
}

export const randomRgb = () => {
    var o = Math.round, r = Math.random, s = 255;
    return 'rgba(' + o(r() * s) + ',' + o(r() * s) + ',' + o(r() * s) + ',' + r().toFixed(1) + ')';
}

export const getDayOfMonth = function (month, year) {
    var date = new Date(Date.UTC(year, month, 1));
    var days = [];
    // let bln = month < 10 ? month.substring(1) : month;
    while (date.getUTCMonth() === month) {
        days.push(YYMMDD(new Date(date)));
        date.setUTCDate(date.getUTCDate() + 1);
    }
    return days;
}

export const getLastDay = (y, m) => {
    var d = new Date(y, m, 0);
    return `${y}-${m}-${d.getDate()}`;
}

export const getAllDay = function (date) {
    var month = date.substring(5, 7);
    var year = date.substring(0, 4);
    var d = new Date(year, month, 0).getDate();
    let day = [];
    for (let i = 1; i <= d; i++)  day.push(`${year}-${month}-${i}`);
    return day;
}

export const numberFormat = function (ini) {
    var formatter = new Intl.NumberFormat("en-GB", { style: "decimal" });
    var nmr = 0;
    if (isNaN(ini)) {
        nmr = 0;
    } else {
        nmr = ini;
    }
    return formatter.format(nmr.toString().replace(/,/g, ""));
}

export const execFunction = function (functionName, context = window) {
    let args = Array.prototype.slice.call(arguments, 2);
    let namespaces = functionName.split(".");
    let func = namespaces.pop();
    for (let i = 0; i < namespaces.length; i++) {
        context = context[namespaces[i]];
    }
    return context[func].apply(context, args);
}

export function openModal(id) {
    let modal = new window.bootstrap.Modal(document.getElementById(id), {});
    modal.show("#" + id);
}

export const api = function (url, data, debug = false) {
    try {
        return new Promise((resolve, reject) => {
            fetch(encodeURI(host + url), {
                method: 'POST',
                body: jsonToForm(data),
            }).then(response => response.text()).then(hasil => {
                if (window.location.hostname === "localhost" && debug === true) console.log(hasil);
                if (isJson(hasil)) {
                    resolve(JSON.parse(hasil));
                } else {
                    resolve({ status: "gagal", pesan: "Terjadi Kesalahan" });
                }
            }).catch((error) => {
                reject(error)
            });
        });
    } catch (e) {
        alert("Terjadi Kesalahan");
        console.log(e);
    }
}

export function isBase64(str) {
    const base64ImageRegex = /^data:image\/(jpeg|png|gif|bmp|webp|svg\+xml);base64,([A-Za-z0-9+/=]+)$/;

    if (!base64ImageRegex.test(str)) {
        return false;
    }

    const parts = str.match(base64ImageRegex);
    const base64Data = parts[2];

    if (base64Data.length < 20) {
        return false;
    }

    return true;
}

export function loading(mode = "on") {
    if (mode == "on") {
        document.getElementById('loadingSpiner').classList.add("loading");
    } else {
        document.getElementById('loadingSpiner').classList.remove("loading");
    }
}

export function convertDateExcel(excelDate, toIndo = false) {
    let excelDateFormatRegex = /^\d+$/;
    if (excelDateFormatRegex.test(excelDate)) {
        let millisecondsPerDay = 24 * 60 * 60 * 1000;
        let excelEpoch = new Date('1899-12-30');

        let daysSinceEpoch = Math.floor(excelDate);
        let millisecondsToAdd = daysSinceEpoch * millisecondsPerDay;
        let jsDate = new Date(excelEpoch.getTime() + millisecondsToAdd);

        let year = jsDate.getFullYear();
        let month = String(jsDate.getMonth() + 1).padStart(2, '0');
        let day = String(jsDate.getDate()).padStart(2, '0');
        let formattedDate = `${year}-${month}-${day}`;

        if (toIndo === false) {
            return formattedDate;
        } else {
            return tanggalIndo(formattedDate);
        }
    } else {
        return excelDate;
    }
}

function jsonToForm(data) {
    const formData = new FormData();
    for (let dt in data) formData.append(dt, data[dt]);
    formData.append("Domain", window.location.hostname);
    formData.append("Token", Token);
    formData.append("openFrom", "Android");
    return formData;
}

export function convertToBase64(url) {
    return new Promise((resolve, reject) => {
        const img = new Image();
        // img.crossOrigin = 'Anonymous'; // Set crossOrigin agar bisa mengakses gambar dari domain lain
        img.src = url;

        img.onload = () => {
            const canvas = document.createElement('canvas');
            const ctx = canvas.getContext('2d');
            canvas.width = img.width;
            canvas.height = img.height;

            ctx.drawImage(img, 0, 0, img.width, img.height);

            try {
                const dataURL = canvas.toDataURL('image/png');
                resolve(dataURL);
            } catch (error) {
                reject(error);
            }
        };

        img.onerror = error => {
            reject(error);
        };
    });
}

export function extensionBase64(base64String) {
    const binaryData = atob(base64String.split(',')[1]);
    const header = binaryData.slice(0, 4);
    let extension = null;
    switch (header) {
        case '\x89PNG':
            extension = 'png';
            break;
        case 'GIF8':
            extension = 'gif';
            break;
        case '\xFF\xD8\xFF':
            extension = 'jpg';
            break;
        default:
            extension = 'dat';
            break;
    }
    return extension;
}

export function sizeBase64(base64String) {
    const base64WithoutMetadata = base64String.split(',')[1];
    const blob = atob(base64WithoutMetadata);
    const arrayBuffer = new ArrayBuffer(blob.length);
    const uint8Array = new Uint8Array(arrayBuffer);
    for (let i = 0; i < blob.length; i++) {
        uint8Array[i] = blob.charCodeAt(i);
    }

    const blobData = new Blob([uint8Array]);
    const fileSizeBytes = blobData.size;
    const fileSizeKB = fileSizeBytes / 1024;

    return {
        sizeBytes: fileSizeBytes,
        sizeKB: Math.round(fileSizeKB)
    };
}

export function compressImageBase64(inputBase64, outputFormat, quality) {
    return new Promise((resolve, reject) => {
        const img = new Image();
        img.src = inputBase64;

        img.onload = () => {
            const canvas = document.createElement('canvas');
            canvas.width = img.width;
            canvas.height = img.height;
            const ctx = canvas.getContext('2d');
            ctx.drawImage(img, 0, 0);
            const compressedBase64 = canvas.toDataURL(`image/${outputFormat}`, quality);
            resolve(compressedBase64);
        };
        img.onerror = (error) => {
            reject(error);
        };
    });
}

export function resizeImageBase64(inputBase64, targetWidth, targetHeight, ext = "jpeg") {
    return new Promise((resolve, reject) => {
        const img = new Image();
        img.src = inputBase64;

        img.onload = () => {
            const aspectRatio = img.width / img.height;
            let newWidth, newHeight;
            if (targetWidth / targetHeight > aspectRatio) {
                newWidth = targetHeight * aspectRatio;
                newHeight = targetHeight;
            } else {
                newWidth = targetWidth;
                newHeight = targetWidth / aspectRatio;
            }

            const canvas = document.createElement('canvas');

            canvas.width = newWidth;
            canvas.height = newHeight;

            const ctx = canvas.getContext('2d');

            ctx.drawImage(img, 0, 0, newWidth, newHeight);

            const resizedBase64 = canvas.toDataURL('image/' + ext);

            resolve(resizedBase64);
        };
        img.onerror = (error) => {
            reject(error);
        };
    });
}

export function openFile(e, compress = false) {
    return new Promise((resolve, reject) => {
        let files = e.target.files;
        let promises = [];

        for (let i = 0; i < files.length; i++) {
            promises.push(processFile(files[i], compress));
        }

        Promise.all(promises)
            .then((hasil) => {
                resolve(hasil);
            })
            .catch((error) => {
                reject(error);
            });
    });
}

function processFile(file, compress) {
    return new Promise((resolve, reject) => {
        let reader = new FileReader();
        let fileExtension = file.name.split('.').pop().toLowerCase();
        let fileSizeKB = Math.round(file.size / 1024);

        reader.onload = async () => {
            try {
                let baru = fileSizeKB > 600 && compress == true ? await compressImageBase64(reader.result, fileExtension, 0.8) : reader.result;
                let img = new Image();
                img.src = baru;

                img.onload = async () => {
                    let width = fileSizeKB > 600 && compress ? img.width / 5 : img.width;
                    let height = fileSizeKB > 600 && compress ? img.height / 5 : img.height;
                    let newRes = fileSizeKB > 600 && compress == true ? await resizeImageBase64(baru, height, width, fileExtension) : baru;
                    resolve({ img: newRes, width: width, height: height, size: fileSizeKB, ext: fileExtension });
                };
            } catch (error) {
                console.error('Error compressing image:', error.message);
                reject(error);
            }
        };

        reader.readAsDataURL(file);
    });
}

export function detailGambar(gambar) {
    let detail = {};
    let img = new Image();
    img.src = gambar;
    img.onload = async () => {
        let size = sizeBase64(gambar).sizeKB;
        let ext = extensionBase64(gambar);
        let width = img.width;
        let height = img.height;
        detail = { size: size, width: width, height: height, ext: ext };
    };
    return detail;
}